import { Injectable} from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { BehaviorSubject, catchError, forkJoin, map, Observable, of, switchMap, tap } from 'rxjs';
import { ContractStepModel, ContractWrapperModel } from '../../../models/contract.model';
import { IMultiPaymentStateCS } from '../../../models/finance.model';
import { ContractDataService } from './contract-data.service';
import { FileDataResponse } from '../../../services/api/documents-api.service';
import { ITaskTargetResponse } from '../../../models/task.model';
import { crc1} from 'crc';
import { MemberService } from '../../../services/member.service';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { MemberModel } from '../../../models/user.model';
const colorForGenAvatars = [
  ['284073', 'DBEAFE'], ['284073', '2563EB'],
  ['284073', 'DBEAFE'], ['284073', '2563EB'],
  ['284073', 'DBEAFE'], ['284073', '2563EB'],
  ['284073', 'DBEAFE'], ['284073', '2563EB'],
  ['284073', 'DBEAFE'], ['284073', '2563EB'],
  ['284073', 'DBEAFE'], ['284073', '2563EB'],
];

/* const colorForGenAvatars = [
  ['d73828', 'e06a4d'], ['005d83', '4f8cad'],
  ['609c40', '9db37d'], ['901f46', 'b06071'],
  ['fbad18', 'ffd594'], ['f57e25', 'fbba89'],
  ['fff08b', 'f8d800'], ['ce9ffc', '7367f0'],
  ['90f7ec', '32ccbc'], ['81fbb8', '28c76f'],
  ['fccf31', 'f55555'], ['f761a1', '8c1bab']
]; */
export interface IAvatarBlobs {
  guid:string,
  blob:any
}
export interface IGenericAvatars {
  background:string,
  text:string
}
@Injectable({
    providedIn: 'root'
})
export class ContractAvatarsService {
  public contractAvatarMap: Map <string,{img:SafeUrl}>|null = null
  public contractGenericAvatarMap: Map <string,IGenericAvatars> = new Map()
  public bSubAvatarsReady:BehaviorSubject<boolean> = new BehaviorSubject(false)
  private apiURL = (window['_env_' as any]['apiURL' as any] || environment.url) + '/api/v1/';
  constructor (
    private memberService:MemberService,
    private contractDataService:ContractDataService,
    private sanitizer : DomSanitizer,
    private http:HttpClient
  ) {}
  private getBlobAvatar(min: boolean, guid: string):Observable<HttpResponse<Blob>> {
    let headers = new HttpHeaders({
      Authorization: localStorage.getItem('access_token')||''
    })
    return this.http.get<Blob>(this.apiURL + 'instance/dag/users/profile/avatar',
      {responseType: 'blob' as 'json', observe: 'response',headers: headers,params:{min:min,user_guid:guid}}
    )
  }
  getAvatars (guids:string []):Observable<Map<string,{img:SafeUrl}>> {
    let getAvatarStrems:Observable<IAvatarBlobs>[] = []
    let guidWithoutAvatars = guids.filter(el=>!this.contractAvatarMap?.get(el)?.img)
    guidWithoutAvatars.forEach(el=>getAvatarStrems.push(
      this.getBlobAvatar(true,el)
      .pipe(
        map(data=>{
        return {
          guid:el,
          blob:this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(data.body!))
        }}),
        catchError(()=>this.setGenericAvatar(el))
      )
    ))
    getAvatarStrems.length === 0? this.bSubAvatarsReady.next(true) : null;
    return forkJoin(getAvatarStrems)
    .pipe(
      map(data => {
        let newMap = new Map(data.map(el=>[el.guid,{img:el.blob}]))
        return this.contractAvatarMap?.size? this.contractAvatarMap = new Map([...this.contractAvatarMap,...newMap])  :  this.contractAvatarMap = newMap 
      }),
      tap(() => this.bSubAvatarsReady.next(true)),
    );
  }
  setGenericAvatar (guid:string,user?:MemberModel):Observable<{guid:string,blob:any}> {
    return of(user).pipe(
        switchMap(res=>res?.email? of(res) :this.memberService.getMemberGuid(guid)),
        tap(user=>{
        let randomNumber = crc1(user.email) % colorForGenAvatars.length;
        //console.log('no avatar for ', user.email)
        let fName = user.firstname ? user.firstname.charAt(0).toUpperCase() : '';
        let lName = user.lastname ? user.lastname.charAt(0).toUpperCase() : '';
        let name = fName + lName;
        let profileBackgroundColor = 'linear-gradient(to right, #' +
            (colorForGenAvatars)[randomNumber][0] + ', #' +
            (colorForGenAvatars)[randomNumber][1] + ')';
        let avatarName = name ? name : user.email.charAt(0).toUpperCase();
        this.contractGenericAvatarMap?.set(guid,{background:profileBackgroundColor,text:avatarName})
        }),
        map(()=>{return {guid:guid,blob:null}})
    )}
  prepareGenericAvatarData(user:MemberModel) {
    
  }
  setAvatarsToShow(stepData:ContractStepModel,contracGuid:string) {
    let targetData = this.contractDataService.getCachedStepTargetData(stepData)
    switch (stepData.target_type) {
      case 'task':
        targetData = targetData as ITaskTargetResponse  
        this.setAvatarsForTask(stepData,targetData,contracGuid)
      break;
      case 'file':
        targetData = targetData as FileDataResponse  
        this.setAvatarsForDocument(stepData,targetData)
      break;
      case 'credit_letter':
        this.setAvatarsForCreditLetters(stepData)
      break;
      case 'multi_payment':
        targetData = targetData as IMultiPaymentStateCS  
        this.setAvatarsForMultiPayment(stepData,targetData,contracGuid)
      break;
      case 'sub_contract':
        targetData = targetData as ContractWrapperModel  
        this.setAvatarsForSubContract(stepData,targetData)
      break;
    }
  }
  setAvatarsForSubContract(stepData:ContractStepModel, targetData:ContractWrapperModel) {
    let allSigners = [...targetData.projects.map(el=>el.members.signatories).flat(), ...targetData.privates];
    this.getAvatars(allSigners.map(el=>el.member.guid)).subscribe(()=>{
      stepData.membersAvatarsToShow = allSigners.map(el=>{
        return {
          guid:el.member.guid,
          state:!!el.verified_at
        }
      })
      
    })
  }
  setAvatarsForDocument(stepData:ContractStepModel, targetData:FileDataResponse) {
    this.getAvatars(targetData.signers.map(el=>el.user.guid)).subscribe(()=>{
      stepData.membersAvatarsToShow =   targetData.signers.map(el=>{
        return {guid:el.user.guid,state:el.sign}
      })
    })
  }
  setAvatarsForCreditLetters(stepData:ContractStepModel) {
    let signatories =stepData.target?.payer_project?.members?.signatories
    if (stepData.target?.payer_private?.member)  {          
      signatories = [{
        member: stepData.target.payer_private.member,
        can_verify: true,
        verified_at: '',
      }] 
    };
    if (signatories) {
      stepData.membersAvatarsToShow = signatories.map(el=>{ 
        let state = !!stepData?.members_signed_step?.find(signer => signer.member_guid === el.member.guid)
        return {
          guid:el.member.guid,
          state:state
        } })
    } 
  }
  setAvatarsForMultiPayment(stepData:ContractStepModel, targetData:IMultiPaymentStateCS, contracGuid:string) {
    let signedMembers = targetData.paymentsData.map(pmt=>pmt.members.map(mem=> mem.contract_member.member.guid)).flat()
    let contractData = this.contractDataService.ContractDataCachedByGuid.get(contracGuid)
    let allSigners = contractData?.allSignatoriesInContract
    stepData.membersAvatarsToShow =  allSigners?.map(el=>{
      return {
        guid:el.member.guid,
        state:signedMembers?.includes(el.member.guid)||false
      }
    })
  }
  setAvatarsForTask(stepData:ContractStepModel, targetData:ITaskTargetResponse, contracGuid:string) {
    let signedMembers = stepData.members_signed_step?.map(el=>el.member_guid)
    let contractData = this.contractDataService.ContractDataCachedByGuid.get(contracGuid)
    let allSigners = contractData?.allSignatoriesInContract
    stepData.membersAvatarsToShow =  allSigners?.map(el=>{
      return {
        guid:el.member.guid,
        state:signedMembers?.includes(el.member.guid)||false
      }
    })
  }
}